import { useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import type { WithDbId } from "adl-gen/common/db";
import type { Product } from "adl-gen/ferovinum/app/db";
import { assertNotUndefined } from "utils/hx/util/types";
import { useAppService } from "../../use-app-service";
import { productKeys } from "../query-keys";

interface GetProductsQueryParams {
  productIds: string[];
  enabled?: boolean;
  onSuccess?: (data?: WithDbId<Product>[]) => void;
}

export const useGetProductsQuery = (params: GetProductsQueryParams) => {
  const { productIds, enabled = true, onSuccess } = params;
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());

  const req = {
    organisationId: organisationId,
    ids: productIds,
  };

  return useQuery({
    queryKey: productKeys.getProducts(productIds),
    queryFn: () => service.getProducts(req),
    enabled,
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
  });
};
